export enum StorageKeys {
  userPrefs = 'userPrefs',
}

export const Storage = localStorage;
